import { render } from "./DocumentStatusViewer.vue?vue&type=template&id=43b8394d"
import script from "./DocumentStatusViewer.vue?vue&type=script&lang=js"
export * from "./DocumentStatusViewer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__